exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label.form-check-label{color:#4e4e4e;margin-bottom:10px;text-align:justify}", ""]);

// exports
